import { createContext } from 'react';

const AmpContext = createContext<boolean>(false);
// eslint-disable-next-line import/no-default-export
export default AmpContext;
